import React from 'react';
import { setCurrentView } from 'core/utils';
import { CloseOutPalletizingViewStore } from 'modules/order/stores';
import { CloseOutPalletizingTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new CloseOutPalletizingViewStore(rootStore), 'closeOutPalletizingViewStore')
class CloseOutPalletizing extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <CloseOutPalletizingTemplate {...this.props} />;
	}
}

export default CloseOutPalletizing;



// WEBPACK FOOTER //
// ./src/modules/order/pages/CloseOutPalletizing.jsx